module.exports = __webpack_public_path__ + "img/product_52.401fb02.webp";